dmx.versions['dmxDataTraversal'] = '2.0.2';